import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


const OrderCard = ({
  id,
  orderNumber,
  orderDate,
  expectedDate,
  productImage,
  productName,
  productCode,
  shopName,
  address,
  totalRupees,
  orderStatus = "Processing",
  editVisible="",
  actionLoading,
  onView,
  onEdit,
  onCancel,
}) => {
  const [showModal, setShowModal] = useState(false);

  const getStatusBadge = (status) => {
    const statusMap = {
      Pending: "bg-warning text-dark",
      Accepted: "bg-success",
      Cancelled: "bg-danger",
      Processing: "bg-primary",
      Draft: "bg-secondary",
    };
    return (
      <span className={`badge ${statusMap[status]}`} style={{ fontSize: "0.7rem" }}>
        {status}
      </span>
    );
  };

  return (
    <>
      <div className="card mb-2 p-2 shadow-sm border-0" style={{ fontSize: "0.82rem" }}>
        <div className="d-flex">
          {/* Enlarged Product Image */}
          <div
            style={{ width: 90, height: 90, cursor: "pointer" }}
            onClick={() => setShowModal(true)}
          >
            <img
              src={productImage}
              alt={productName}
              className=""
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </div>

          {/* Details Section */}
          <div className="flex-grow-1 ms-3">
            <strong>{productName}</strong>

            {/* Code + Amount row */}
            <div className="d-flex justify-content-between align-items-center" style={{ fontSize: "0.75rem" }}>
              <span className="text-muted">Code: {productCode}</span>
              <span className="text-success fw-semibold">₹{totalRupees}</span>
            </div>

            {/* Order#, Status in single line */}
            <div className="d-flex justify-content-between align-items-center" style={{ fontSize: "0.75rem" }}>
              <span>
                Order#: <strong>{orderNumber}</strong>
              </span>             
              {getStatusBadge(orderStatus)}
            </div>

            {/* Shop Address */}
            <div className="text-muted" style={{ fontSize: "0.74rem" }}>
              {shopName}, {address}
            </div>

            {/* Dates */}
            <div className="d-flex justify-content-between align-items-center mt-1">
              <div className="text-muted" style={{ fontSize: "0.7rem" }}>
                📅 {orderDate} → {expectedDate}
              </div>
              <div className="d-flex gap-1">
                <button
                  className="btn btn-outline-primary btn-xs px-2 py-0"
                  style={{ fontSize: "0.7rem", lineHeight: "1.6" }}
                  onClick={onView}
                >
                  View
                </button>
                <button
                  className={`btn btn-outline-secondary btn-xs px-2 py-0 ${editVisible}`}
                  style={{ fontSize: "0.7rem", lineHeight: "1.6" }}
                  onClick={onEdit}
                >
                  Edit
                </button>
                <button                  
                  className={`btn btn-danger btn-xs px-2 py-0 ${editVisible}`}
                  style={{ fontSize: "0.7rem", lineHeight: "1.6" }}
                  onClick={onCancel}
                  disabled={id === actionLoading?.deleteId} // Optional: disable while loading
                >
                  {id === actionLoading?.deleteId ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  ) : (
                    "Cancel"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for enlarged image */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="md">
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "1rem" }}>{productName}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <img
            src={productImage}
            alt={productName}
            style={{ maxWidth: "100%", maxHeight: "400px", objectFit: "contain" }}
            className="rounded"
          />
        </Modal.Body>
        <Modal.Footer className="py-2">
          <Button variant="secondary" size="sm" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OrderCard;
